<template>
	<VContainer
		v-if="breadcrumbItems.length > 0"
		class="px-10"
		fluid
	>
		<VRow>
			<VCol>
				<VBreadcrumbs :items="breadcrumbItems">
					<template #divider>
						<VIcon>{{ mdiChevronRight }}</VIcon>
					</template>
				</VBreadcrumbs>
			</VCol>
		</VRow>
	</VContainer>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';
	import { mdiChevronRight } from '@mdi/js';
	import { RolesEnum } from '@/types/enum/RolesEnum';
	import { mapGetters } from 'vuex';

	interface BreadcrumbItem {
		text: string;
		to?: string | object | null;
		disabled?: boolean;
	}

	@Component({
		computed: mapGetters('auth', ['getUserType'])
	})
	export default class Breadcrumbs extends Vue {
		mdiChevronRight = mdiChevronRight;
		isSspa = Vue.prototype.$SSPA_ENABLED;

		get breadcrumbItems(): BreadcrumbItem[] {
			if (this.getUserType === RolesEnum.TEMOIN) {
				return [];
			}

			const breadcrumb = this.$route?.meta?.breadcrumb as BreadcrumbItem[] | undefined;
			if (!Array.isArray(breadcrumb) || breadcrumb.length === 0) {
				return [];
			}

			const items = this.isSspa
				? [{ text: 'Accueil', to: { name: 'home' }, disabled: false }, ...breadcrumb]
				: breadcrumb;

			return items.map((item: BreadcrumbItem) => {
				if (!item.to) {
					return item;
				}

				if (item.to === 'detailsDossier') {
					const hasDossierId = Boolean(this.$route.params.dossierId);
					return {
						...item,
						to: hasDossierId
							? this.$router.resolve({
								name: 'detailsDossier',
								params: { dossierId: this.$route.params.dossierId }
							}).href
							: undefined,
						disabled: !hasDossierId
					};
				}

				if (typeof item.to === 'object') {
					return {
						...item,
						to: this.$router.resolve(item.to).href,
						disabled: false
					};
				}

				return item;
			}).filter((item): item is BreadcrumbItem => Boolean(item));
		}
	}
</script>

<style lang="scss" scoped>
:deep(.v-breadcrumbs) {
	padding: 0;
	margin-bottom: 10px;

	a {
		color: #040404;
	}

	li div {
		color: gray;
	}

	li:nth-child(even) {
		padding: 0;
	}
}
</style>
